import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { t } from '../../lib/translations';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { Loader2 } from 'lucide-react';

const DashboardLayout = () => {
  const { isAuthenticated, loading } = useAuth();
  const { lang } = useLanguage();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-10 h-10 animate-spin text-primary" />
          <p className="text-muted-foreground">{t('action_loading', lang)}</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Get page title based on route
  const getPageTitle = () => {
    const path = location.pathname;
    const titleKeys = {
      '/dashboard/admin': 'sidebar_dashboard',
      '/dashboard/teacher': 'sidebar_dashboard',
      '/dashboard/student': 'sidebar_my_dashboard',
      '/dashboard/partner': 'sidebar_dashboard',
      '/students': 'sidebar_students',
      '/courses': 'sidebar_courses',
      '/my-courses': 'sidebar_my_courses',
      '/files': 'sidebar_dossiers',
      '/my-files': 'sidebar_my_dossier',
      '/payments': 'sidebar_payments',
      '/my-payments': 'sidebar_my_payments',
      '/partners': 'sidebar_partners',
      '/messages': 'sidebar_messages',
      '/statistics': 'sidebar_stats',
      '/settings': 'sidebar_settings',
      '/appointments': 'sidebar_appointments',
      '/bookings': 'sidebar_calendar',
      '/booking-types': 'sidebar_calendar',
      '/resources': 'sidebar_resources',
      '/my-candidates': 'sidebar_my_candidates',
      '/dossiers': 'sidebar_dossiers',
      '/arrivals': 'sidebar_arrivals',
      '/leads': 'sidebar_leads',
      '/contact-messages': 'sidebar_contact',
      '/analytics/teachers': 'sidebar_analytics',
      '/admin/backups': 'sidebar_backups',
    };
    const key = titleKeys[path];
    return key ? t(key, lang) : 'Speak&Move';
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar />
      <div className="dashboard-main md:ml-64 min-h-screen flex flex-col">
        <Topbar pageTitle={getPageTitle()} />
        <main className="flex-1">
          <div className="p-6 md:p-8 pt-4">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
